import React, { useState, FC } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import { RiShareBoxFill } from 'react-icons/ri';
import dynamic from 'next/dynamic';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const ShareModal = dynamic(() =>
  import('views/rebranded-module/common/components/UI/Share/ShareModal').then(
    (file) => file.ShareModal,
  ),
);

interface ShareContent {
  shareText: string;
  copyLink: string;
  linkCopiedText: string;
  whatsApp: string;
  facebook: string;
  email: string;
  shareJourney: string;
}

interface ShareProps {
  journeyName?: string;
  shareModalTitle?: string;
  content?: ShareContent;
}
const Share: FC<ShareProps> = (props) => {
  const { journeyName, shareModalTitle, content: propsContent } = props;
  const [open, setOpen] = useState(false);
  const shareContentFromUseContent = useContent('ShareLinkComponent');
  const content = shareContentFromUseContent || propsContent;

  const handleClose = () => setOpen(false);
  const handleClickOpen = () => setOpen(true);

  return (
    <Box>
      <Button
        className="showDESKTOP"
        variant="text"
        color="secondary"
        onClick={handleClickOpen}
        startIcon={<RiShareBoxFill />}>
        {content.shareText}
      </Button>

      <IconButton
        className="showTABLET"
        color="secondary"
        onClick={handleClickOpen}>
        <RiShareBoxFill />
      </IconButton>

      {open && (
        <ShareModal
          open={open}
          handleClose={handleClose}
          content={content}
          journeyName={journeyName}
          shareModalTitle={shareModalTitle}
        />
      )}
    </Box>
  );
};

export { Share };
